export type OrganizationLimit = {
  usage: number;
  max: number;
  unlimited: boolean;
};

export enum AuthenticationMode {
  Email = 'Email Address',
  SsoEmail = 'SSO + Email Address',
  Sso = 'SSO Only',
  OAuth = 'OAuth Only',
}

export enum UserOrgRoleManagement {
  /**
   * User roles are managed via the FOSSA UI.
   */
  FOSSA = 'fossa',
  /**
   * User roles are managed via the identity provider.
   * Currently, this is only implemented for SAML.
   */
  IDP = 'idp',
  /**
   * User roles are managed via the FOSSA UI and the IDP. with the constraint that the IDP is not able
   * to remove an organization role from a user. A blank or empty `role` attribute will be interpreted as
   * maintaining the user's existing organization role.
   */
  MIXED = 'mixed',
}

export enum UserTeamAndRoleManagement {
  /**
   * Users are assigned to teams and their team roles are managed via the FOSSA UI.
   */
  FOSSA = 'fossa',
  /**
   * Users are assigned to teams via the identity provider, but their team roles are managed via the FOSSA UI.
   * This is currently only implemented for SAML.
   */
  IDP_TEAMS_FOSSA_ROLES = 'idp_teams_fossa_roles',
  /**
   * Users are assigned to teams and their their role on each team is managed via the identity provider.
   * This is currently only implemented for SAML.
   */
  IDP = 'idp',
  /**
   * Users are assigned to teams and their team roles are managed via the FOSSA UI and the IDP, with the constraint
   * that the IDP is not able to remove a user from all teams since sending an empty/missing team response is interpreted as
   * maintaining the user's existing team memberships.
   */
  MIXED = 'mixed',
}
